import * as React from 'react';
import { lazyLoad } from '../../utils/loadable';
import { LoadingIndicator } from '../../atoms/LoadingIndicator';
import styled from 'styled-components/macro';

const LoadingWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserAlreadyConfirmed = lazyLoad(
  () => import('./index'),
  module => module.UserAlreadyConfirmed,
  {
    fallback: (
      <LoadingWrapper>
        <LoadingIndicator />
      </LoadingWrapper>
    ),
  },
);